import { getStoreDetails } from '../api/store';
import { site } from '../config';
import ErrorBox from '../generic/ErrorBox';
import Icon from '../generic/Icon';
import InfoBox from '../generic/InfoBox';
import Spinner from '../generic/Spinner';
import type { StoreWithOpeningHours } from '../model/types';
import useAsyncMemo from '../utils/useAsyncMemo';
import OpenMapApplicationAction from './OpenMapApplicationAction';
import OpeningsTable from './OpeningsTable';

interface Props {
    storeId: string;
}

export default function StoreDetails({ storeId }: Props) {
    const [store, isLoading, error] = useAsyncMemo(
        async (storeId: string) => {
            const data = await getStoreDetails(storeId);
            return data;
        },
        [storeId],
    );

    return (
        <div>
            {!store ? (
                <Spinner isSpinning={isLoading} />
            ) : (
                <>
                    <ErrorBox errors={error} />
                    <StoreDetailsHeader store={store} />
                    <OpeningsTable openingHours={store.openingHours.currentOpeningList} />
                </>
            )}
        </div>
    );
}

export const StoreSelectionLink = ({ name }: { name: string }) => (
    <a className="btn-secondary" href={site.searchStockURL(name)}>
        Se vareutvalget i denne butikken
    </a>
);

interface StoreDetailsHeaderProps {
    store: StoreWithOpeningHours;
    showAssortment?: boolean;
    className?: string;
}

export function StoreDetailsHeader({ store, showAssortment = false, className }: StoreDetailsHeaderProps) {
    return (
        <div className={className}>
            {store.address && (
                <p>
                    {'  '}
                    <OpenMapApplicationAction
                        place={`Vinmonopolet ${store.displayName} ${store.address.line1}`}
                        latitude={store.geoPoint.latitude}
                        longitude={store.geoPoint.longitude}
                    >
                        {store.address.line1}, {store.address.postalCode} {store.address.town}
                        <Icon className="icon-external-link" renderWithSpan />
                    </OpenMapApplicationAction>
                </p>
            )}
            {showAssortment && store.assortment && (
                <p>
                    {store.assortment} <a href={site.storeCategoriesUrl()}>Les mer om kategoriene</a>
                </p>
            )}
            {store.infoMessage && <InfoBox message={store.infoMessage} />}
        </div>
    );
}
